import * as actionTypes from "./client.types.js";

export function newActiveClient(client) {
  return {
    type: actionTypes.NEW_ACTIVE_CLIENT,
    client: client,
  };
}

export function resetActiveClient() {
  return {
    type: actionTypes.RESET_ACTIVE_CLIENT,
  };
}
